import Swal from 'sweetalert2';
export const showWarning = (text, preConfirm, confirmButtonText) => {
  return Swal.fire({
    text,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d30b0b',
    cancelButtonColor: '#757f91',
    confirmButtonText,
    showLoaderOnConfirm: true,
    preConfirm,
    allowOutsideClick: () => !Swal.isLoading(),
  });
};

export const showError = (title, text) => {
  Swal.fire({
    icon: 'error',
    title,
    text,
  });
};
